/** Hostname without a leading `www.`; falls back to the raw string for unparsable input. */
export function domainOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
